import React, { useState } from 'react';

import { useDevice } from '@tecma/ds';
import classNames from 'classnames';

import type { Quote } from 'types/quote';

import { CardQuote } from 'components/CardQuote';
import { QuoteDetailsModal } from 'components/QuoteDetailsModal';

import './card-quote-container.scss';
import { SwiperCarousel } from 'components/SwiperCarousel';

import type { SwiperProps } from 'swiper/react';
import { useQuoteDetailsModal } from 'hooks/useQuoteDetailsModal';

interface CardQuoteContainerRequiredProps {
  quotes: Quote[];
  apartmentName: string;
  onQuoteDeleted: () => void;
}

// Optional Props
interface CardQuoteContainerOptionalProps {
  label?: string;
  showPagination?: boolean;
  showSidebar?: boolean;
  slidesPerView?: number | 'auto';
}

// Combined required and optional props to build the full prop interface
export interface CardQuoteContainerProps extends CardQuoteContainerRequiredProps, CardQuoteContainerOptionalProps {}

const CardQuoteContainer: React.FC<CardQuoteContainerProps> = ({
  quotes,
  label,
  showPagination,
  showSidebar,
  slidesPerView = 'auto',
  apartmentName,
  onQuoteDeleted,
}) => {
  const device = useDevice();
  // const [selectedQuoteId, setSelectedQuoteId] = useState<string>();
  const cardQuoteContainerClassList = classNames('card-quote-container');

  // const selectedQuote = quotes?.find((quote) => quote.id === selectedQuoteId) ?? quotes[0];
  // const toggleQuoteDetailsModal = (quoteId?: string) => {
  //   setSelectedQuoteId(quoteId);
  //   setIsQuoteDetailsModalOpen(!isQuoteDetailsModalOpen);
  // };
  const swiperProps: SwiperProps = {
    slidesPerView,
    spaceBetween: '8',
    allowTouchMove: device.type !== 'desktop',
  };
  if (showPagination) {
    swiperProps.pagination = true;
  }

  const { isQuoteDetailsModalOpen, handleOnClose, selectedQuote, quoteList, onSelectQuote, getModalTitle } = useQuoteDetailsModal({
    quotes,
    apartmentName,
  });

  return (
    <>
      <div className={cardQuoteContainerClassList}>
        <div className='card-quote-container-header'>{label && <span>{label}</span>}</div>
        <div className='quotes'>
          <SwiperCarousel
            swiperProps={swiperProps}
            hideArrowButtons={device.type !== 'desktop'}
            className={quotes.length == 1 ? 'single-quote' : ''}
            items={quotes.map((quote) => (
              <CardQuote {...quote} onClick={onSelectQuote} key={quote.name} />
            ))}
          />
        </div>
      </div>
      {isQuoteDetailsModalOpen && (
        <QuoteDetailsModal
          isOpen={isQuoteDetailsModalOpen}
          onClose={handleOnClose}
          quoteList={showSidebar ? quoteList : undefined}
          selectedQuote={selectedQuote}
          getModalTitle={getModalTitle}
          onQuoteDeleted={onQuoteDeleted}
        />
      )}
    </>
  );
};

export default React.memo(CardQuoteContainer);
